import { render, staticRenderFns } from "./homeWork.vue?vue&type=template&id=e7a10522&scoped=true"
import script from "./homeWork.vue?vue&type=script&lang=js"
export * from "./homeWork.vue?vue&type=script&lang=js"
import style0 from "./homeWork.vue?vue&type=style&index=0&id=e7a10522&lang=scss"
import style1 from "./homeWork.vue?vue&type=style&index=1&id=e7a10522&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a10522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7a10522')) {
      api.createRecord('e7a10522', component.options)
    } else {
      api.reload('e7a10522', component.options)
    }
    module.hot.accept("./homeWork.vue?vue&type=template&id=e7a10522&scoped=true", function () {
      api.rerender('e7a10522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/practice/homeWork.vue"
export default component.exports